export const useGetQueryParam = (param: string) =>
  location.href.split(param)?.[1]
